export default function replaceStorageURLsFromFirebaseToCloudflare(url: string | undefined) {
  if (!url) return url

  //* For CSS url styles I first remove the url( and ) from the string
  let isCSSurl = false
  if (url.startsWith('url(')) {
    isCSSurl = true
    url = url.slice(4, url.length - 1)
  }

  const regex =
    /https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/savvy-flow-uploads\/o\/([^?]+)\?[^"'\s`]+/

  url = url.replace(regex, (_match, fileName) => {
    return `https://assets-modified.embeddables.com/${fileName}`
  })

  if (isCSSurl) url = `url(${url})`

  return url
}

/*
  https://firebasestorage.googleapis.com/v0/b/savvy-flow-uploads/o/hD1NU4pDpI0SpkDov3f2%2Fcentral_escudo_5189770319168348.jpg?alt=media&token=d7f83588-0325-4411-afc3-c671da3c4ee3
  https://assets-modified.embeddables.com/hD1NU4pDpI0SpkDov3f2/central_escudo_5189770319168348.jpg
*/
